export default "__VITE_ASSET__B8e8P0RP__"